import React, { useState, useEffect, useRef } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { useAuth0, withAuth0 } from "@auth0/auth0-react";
import { API_URL, WORKFLOW_FILTER } from "../../../ConstVariable";
import { useSelector } from "react-redux";
import styles from "./MultipleDropdown.module.css";
//NOTE:- This component shows the center list in dropdown , here we can select the multiple center
const MultipleDropdown = ({
  showCenterDropdown,
  setSearchDetails,
  setSelectedCenterList,
  rerender,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const GetAuthToken = async () => {
    const token = await getAccessTokenSilently();
    return token;
  };

  const inputRef = useRef();
  const { operatorAssignedCenters } = useSelector((state) => state);
  const [checkedCenter, setCheckedCenter] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [filteredCenterList, setFilteredCenterList] = useState([]);
  const [showDropDown, setShowDropDown] = useState("none");
  const [selectAllCenterCheckboxStatus, SetSelectAllCenterCheckboxStatus] =
    useState(false);
  useEffect(() => {
    setCenterList([...operatorAssignedCenters]);
    setFilteredCenterList([...operatorAssignedCenters]);
  }, []);

  useEffect(() => {
    setShowDropDown("none");
  }, [rerender]);

  const dropDownHandler = () => {
    if (showDropDown === "none") {
      setShowDropDown("");
    } else {
      setShowDropDown("none");
    }
  };

  //NOTE:- Here we are handling the center checkBox and storing the checked center to checkedCenter state
  const inputCheckBoxHandler = (e, id, name) => {
    let data = {
      id: id,
      centerName: name,
    };
    let idx = filteredCenterList.findIndex(
      (item) => parseInt(item.center_id) === parseInt(id)
    );
    let center_data = filteredCenterList[idx];
    let selected_centers = checkedCenter;
    if (filteredCenterList[idx].isChecked) {
      center_data = {
        ...center_data,
        isChecked: false,
      };
      selected_centers = selected_centers.filter(
        (item) =>
          parseInt(item.id) !== parseInt(filteredCenterList[idx].center_id)
      );
      SetSelectAllCenterCheckboxStatus(
        checkSelectedAll(filteredCenterList, selected_centers)
      );
      setCheckedCenter(selected_centers);
    } else {
      center_data = {
        ...center_data,
        isChecked: true,
      };
      SetSelectAllCenterCheckboxStatus(
        checkSelectedAll(filteredCenterList, [...selected_centers, data])
      );
      setCheckedCenter((prevState) => [...prevState, data]);
    }
    filteredCenterList[idx] = center_data;
    setFilteredCenterList(filteredCenterList);
  };

  //  This function verifies if all filtered centers  are marked as active.then set select-all-centers checkbox  active and vice-versa.
  const checkSelectedAll = (filteredList, selectedCenters) => {
    let selected_center_count_in_filtered_center = 0;
    filteredList.map((center_obj) => {
      selectedCenters.map((selected_center_obj) => {
        if (selected_center_obj.id == center_obj.center_id) {
          selected_center_count_in_filtered_center++;
        }
        return;
      });
      return center_obj;
    });

    if (
      selected_center_count_in_filtered_center == filteredList.length &&
      selected_center_count_in_filtered_center != 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const searchInputHandler = () => {
    let input_value = inputRef.current.value;
    let filteredcenters = centerList?.filter(
      (item) =>
        item.center_name
          .toLowerCase()
          .includes(input_value.trim().toLowerCase()) ||
        item.center_prefix
          ?.toLowerCase()
          .includes(input_value.trim().toLowerCase())
    );
    filteredcenters = filteredcenters.map((filter_center_obj) => {
      filter_center_obj = { ...filter_center_obj, isChecked: false };
      checkedCenter.map((checked_center_obj) => {
        if (checked_center_obj.id == filter_center_obj.center_id) {
          filter_center_obj = { ...filter_center_obj, isChecked: true };
        }
        return;
      });
      return filter_center_obj;
    });
    setFilteredCenterList(filteredcenters);
    SetSelectAllCenterCheckboxStatus(
      checkSelectedAll(filteredcenters, checkedCenter)
    );
  };


  const selectAllHandler = (selectAllStatus) => {
    let selectedCenters = checkedCenter;
    let filteredCenters = filteredCenterList;
    filteredCenters.map((center_obj) => {
      let is_obj_selected = false;
      selectedCenters.map((selected_center) => {
        if (selected_center.id == center_obj.center_id) {
          is_obj_selected = true;
        }
      });

      if (!is_obj_selected && selectAllStatus) {
        selectedCenters.push({
          id: center_obj.center_id,
          centerName: center_obj.center_prefix,
        });
      }
      if (is_obj_selected && !selectAllStatus) {
        selectedCenters = selectedCenters.filter(
          (item) => parseInt(item.id) !== parseInt(center_obj.center_id)
        );
      }
      return center_obj;
    });
    filteredCenters = filteredCenterList.map((item) => {
      return { ...item, isChecked: selectAllStatus };
    });
    setCheckedCenter(selectedCenters);
    setFilteredCenterList(filteredCenters);
    SetSelectAllCenterCheckboxStatus(selectAllStatus);
  };


  useEffect(() => {
    setSelectedCenterList(checkedCenter);
    setSearchDetails(checkedCenter);
  }, [checkedCenter]);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          border: "1px solid lightgrey",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "7px",
          cursor: "pointer",
          width: "180px",
          borderRadius: "5px",
          background: "white",
        }}
        onClick={dropDownHandler}
      >
        {checkedCenter.length == 0 ? (
          <span style={{ fontSize: "15px" }}>--select--</span>
        ) : (
          <span>{checkedCenter.length} selected </span>
        )}

        {showDropDown === "" ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </div>
      <div>
        <div
          style={{
            border: "1px solid ",
            position: "absolute",
            display: showDropDown,
            width: "250px",
            top: "45px",
            left: "-0px",
            height: "300px ",
            overflowY: "auto",
            background: "#F1F1F1",
          }}
        >
          <div>
            <div style={{ width: "100%", padding: "2px" }}>
              <input
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  width: "100%",
                }}
                ref={inputRef}
                onChange={searchInputHandler}
                placeholder="Search..."
              />
            </div>
            <div style={{display:"flex",paddingTop:"10px"}}>
            <div
              style={{
                color: "blue",
                padding: "2px 2px 2px 12px",
                cursor: "pointer",
              }}
              onClick={() => {
                selectAllHandler(true);
              }}
            >
               Select all
            </div>
            <div
              style={{
                color: "blue",
                padding: "2px 2px 2px 2px",
                cursor: "pointer"
              }}
            >
            -
            </div>
            <div
              style={{
                color: "blue",
                padding: "2px",
                cursor: "pointer"
              }}
              onClick={() => {
                selectAllHandler(false);
              }}
            >
             Unselect all
            </div>
            </div>
            {filteredCenterList.length != 0 &&
              filteredCenterList.map((item) => (
                <div
                  key={item.center_name}
                  style={{
                    display: "flex",
                    margin: "10px",
                    alignItems: "center",
                  }}
                  className={styles.dropdown}
                >
                  <div>
                    <input
                      type="checkbox"
                      style={{ marginRight: "10px" }}
                      name="centerList"
                      checked={item.isChecked}
                      onChange={(e) =>
                        inputCheckBoxHandler(
                          e,
                          item.center_id,
                          item.center_name
                        )
                      }
                    />
                  </div>
                  <div style={{ fontSize: "15px" }}>{item.center_name}</div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultipleDropdown;
